import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import Select from "react-select";
import Swal from "sweetalert2";

import { AuthContext } from '../../context/AuthContext';
import { RelatorioVendaContext } from '../../context/RelatorioVendaContext';
import { RelatorioVendaType, CreateRelatorioVendaType, EditRelatorioVendaType, AlunoVendedorType, CreateRelacaoRelatorioVendaType, EditRelacaoRelatorioVendaType, AtualizarStatusRelatorioVendaRequest } from '../../context/hooks/useRelatorioVenda';
import { ContratoContext } from '../../context/ContratoContext';
import { AlunoContext } from '../../context/AlunoContext';
import { TerceiroContext } from '../../context/TerceiroContext';
import api from '../../api';

import useUser from '../../context/hooks/useUser';
import { createPermissionChecker, PermissionModule } from '../../types/permissions';
import { set } from 'lodash';
import { AlunoType } from '../../context/hooks/useAluno';

const RelatorioVenda = () => {
    const { objUserTk } = useContext(AuthContext);
    const { getRelatorioVendaPaged, listRelatorioVenda, relatorioVendaPageCount, createRelatorioVenda, updateRelatorioVenda, deleteRelatorioVenda, getAlunosVendedoresByRelatorioId, adicionarRelacoesAoRelatorio, updateRelacoesRelatorioVenda, removerRelacaoRelatorioVenda, downloadRelatorioVendaPdf, downloadRelatorioReduzidoVendaPdf, getAlunosVendedoresPaged, listRelacaoAlunosVendedores, relacaoAlunosVendedoresPageCount, atualizarStatusLote, validarAlunoEmOutroRelatorioEmRota, validarVendedorComContratosAbertos, validarAlunoPertenceAoContrato, downloadRelatorioVendasAtivasPdf, downloadRelatorioMultiplosPdf } = useContext(RelatorioVendaContext)
    const { getAlunoPaged, setListAluno, listAluno, alunoPageCount, setAlunoPageCount, handleGetAlunoById, handleGetAlunoByReferenceCode } = useContext(AlunoContext);
    const { handleGetVendedoresByEmpresa, listVendedores } = useContext(TerceiroContext);
    const { handleGetContratoByEmpresaId, listContrato } = useContext(ContratoContext);
    const [loaging, setLoading] = useState(true);
    const { getPermissionsByUser, userPermissions, useLegacyPermissions, modulePermissions } = useUser();
    const hasPermission = createPermissionChecker(useLegacyPermissions, userPermissions, modulePermissions);
    const [modoRelatorio, setModoRelatorio] = useState<'porContrato' | 'porAluno'>('porContrato');
    const [buscaCodigoAluno, setBuscaCodigoAluno] = useState("");

    const [newRelatorioVenda, setNewRelatorioVenda] = useState<CreateRelatorioVendaType>({
        id: 0,
        date: "",
        status: 0,
        checked: false,
        dateChecked: "",
        empresaId: 0,
        contratoId: 0,
    });
    const [editingRelatorioVenda, setEditingRelatorioVenda] = useState<EditRelatorioVendaType | null>(null);
    const [editingRelacaoRelatorioVenda, setEditingRelacaoRelatorioVenda] = useState<EditRelacaoRelatorioVendaType | null>(null);

    const [dataSearch, setDataSearch] = useState({ RelatorioId: 0, ContratoId: 0, Status: 0, InitialDate: "", FinalDate: "" });
    const [alunoSearch, setAlunoSearch] = useState({ name: "", alunoId: "" });
    const [alunoVendedorSearch, setAlunoVendedorSearch] = useState({ name: "", alunoId: "" });

    const [alunosVinculados, setAlunosVinculados] = useState<AlunoVendedorType[]>([]);
    const [relacoesAlunoVendedor, setRelacoesAlunoVendedor] = useState<CreateRelacaoRelatorioVendaType[]>([]);
    const [alunosPendentesInfo, setAlunosPendentesInfo] = useState<Record<number, { referenceCode?: number; name: string }>>({});
    const [vendedorAtivo, setVendedorAtivo] = useState<number>(0);

    const [codigoAluno, setCodigoAluno] = useState<number>(0);
    const [numeroFotos, setNumeroFotos] = useState<number>(0);
    const [codigoAlunoEdicao, setCodigoAlunoEdicao] = useState<number>(0);
    const [numeroFotosEdicao, setNumeroFotosEdicao] = useState<number>(0);
    const [nomeFormando, setNomeFormando] = useState("");
    const [nomeFormandoEdicao, setNomeFormandoEdicao] = useState("");
    const [buscandoNomeFormando, setBuscandoNomeFormando] = useState(false);
    const [buscandoNomeFormandoEdicao, setBuscandoNomeFormandoEdicao] = useState(false);
    const [vendedorAtivoEdicao, setVendedorAtivoEdicao] = useState<number>(0);

    const [alunosSelecionadosIds, setAlunosSelecionadosIds] = useState<number[]>([]);
    const [novoStatusLote, setNovoStatusLote] = useState<number>(0);
    const [todosSelecionados, setTodosSelecionados] = useState(false);

    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editRelacaoModalOpen, setEditRelacaoModalOpen] = useState(false);

    const [relatoriosSelecionadosIds, setRelatoriosSelecionadosIds] = useState<number[]>([]);

    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [vendedorFiltroExport, setVendedorFiltroExport] = useState<number>(0);
    const [statusFiltroExport, setStatusFiltroExport] = useState<number>(0);

    useEffect(() => {
        setLoading(true);

        handleGetContratoByEmpresaId(objUserTk.EmpresaId);
        handleGetVendedoresByEmpresa(objUserTk.EmpresaId);

        getRelatorioVendaPaged(1, 0, objUserTk?.EmpresaId, 0, 9)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar relatórios:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const buscarNomeFormandoPorCodigo = async (codigo: number) => {
        if (!codigo || codigo <= 0) return "";

        const alunoCarregado = listAluno.find(aluno => Number(aluno.referenceCode) === Number(codigo));
        if (alunoCarregado) return alunoCarregado.name;

        try {
            const response = await api.get<AlunoType>(`/Aluno/getAlunoByReferenceCode/${codigo}`);
            return response.data?.name || "";
        } catch {
            return "";
        }
    };

    useEffect(() => {
        let active = true;

        if (!codigoAluno) {
            setNomeFormando("");
            setBuscandoNomeFormando(false);
            return;
        }

        const timeoutId = window.setTimeout(async () => {
            setBuscandoNomeFormando(true);
            const nome = await buscarNomeFormandoPorCodigo(codigoAluno);
            if (active) {
                setNomeFormando(nome);
                setBuscandoNomeFormando(false);
            }
        }, 400);

        return () => {
            active = false;
            window.clearTimeout(timeoutId);
        };
    }, [codigoAluno, listAluno]);

    useEffect(() => {
        let active = true;

        if (!codigoAlunoEdicao) {
            setNomeFormandoEdicao("");
            setBuscandoNomeFormandoEdicao(false);
            return;
        }

        const timeoutId = window.setTimeout(async () => {
            setBuscandoNomeFormandoEdicao(true);
            const nome = await buscarNomeFormandoPorCodigo(codigoAlunoEdicao);
            if (active) {
                setNomeFormandoEdicao(nome);
                setBuscandoNomeFormandoEdicao(false);
            }
        }, 400);

        return () => {
            active = false;
            window.clearTimeout(timeoutId);
        };
    }, [codigoAlunoEdicao, listAluno]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getRelatorioVendaPaged(value, dataSearch.RelatorioId, objUserTk.EmpresaId, dataSearch.ContratoId, 9, dataSearch.Status, dataSearch.InitialDate, dataSearch.FinalDate);
    };

    const onChangeAlunoPaginationCommon = async (e: any, value: number) => {
        if (!newRelatorioVenda.contratoId) return;
        await getAlunoPaged(value, newRelatorioVenda.contratoId, 10, alunoSearch.name, Number(alunoSearch.alunoId));
    };

    const onChangeAlunoPaginationEditar = async (e: any, value: number) => {
        if (editingRelatorioVenda?.contratoId) {
            await getAlunoPaged(value, editingRelatorioVenda.contratoId, 10, alunoSearch.name, Number(alunoSearch.alunoId));
        }
    };

    const onChangeAlunoVendedorPagination = async (e: any, value: number) => {
        if (editingRelatorioVenda?.id) {
            await getAlunosVendedoresPaged(editingRelatorioVenda.id, value, 10, alunoVendedorSearch.name, Number(alunoVendedorSearch.alunoId));
        }
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataSearch({ ...dataSearch, [e.target.name]: e.target.value });
    };

    const handleClearFilters = () => {
        setDataSearch({ RelatorioId: 0, ContratoId: 0, Status: 0, InitialDate: "", FinalDate: "" });
        setLoading(true);
        getRelatorioVendaPaged(1, 0, objUserTk?.EmpresaId, 0, 9)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        getRelatorioVendaPaged(1, dataSearch.RelatorioId, objUserTk?.EmpresaId, dataSearch.ContratoId, 9, dataSearch.Status, dataSearch.InitialDate, dataSearch.FinalDate)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleAlunoSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!newRelatorioVenda.contratoId) return;

        setLoading(true);
        getAlunoPaged(1, newRelatorioVenda.contratoId, 10, alunoSearch.name, alunoSearch.alunoId ? Number(alunoSearch.alunoId) : undefined)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleAlunoSearchSubmitEditar = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!editingRelatorioVenda?.contratoId) return;

        setLoading(true);
        getAlunoPaged(1, editingRelatorioVenda.contratoId, 10, alunoSearch.name, alunoSearch.alunoId ? Number(alunoSearch.alunoId) : undefined)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleAlunoVendedorSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!editingRelatorioVenda?.id) return;

        setLoading(true);
        getAlunosVendedoresPaged(editingRelatorioVenda.id, 1, 10, alunoVendedorSearch.name, alunoVendedorSearch.alunoId ? Number(alunoVendedorSearch.alunoId) : undefined)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    }

    //--------------------------------------------

    const formatRelatorioVendaData = (relatorioVenda: any) => ({
        ...relatorioVenda,
        id: Number(relatorioVenda.id),
        date: relatorioVenda.date ? relatorioVenda.date : null,
        status: relatorioVenda.status ? Number(relatorioVenda.status) : 1,
        checked: Boolean(relatorioVenda.checked),
        dateChecked: relatorioVenda.dateChecked ? relatorioVenda.dateChecked : null,
        empresaId: objUserTk?.EmpresaId || 0,
        contratoId: modoRelatorio === 'porContrato' && relatorioVenda.contratoId
            ? Number(relatorioVenda.contratoId)
            : undefined,
        relacoesAlunoVendedor: relacoesAlunoVendedor
    });

    const handleCreateInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setNewRelatorioVenda(prevRelatorioVenda => ({
                ...prevRelatorioVenda,
                [name]: checked,
            }));
        } else {
            setNewRelatorioVenda(prevRelatorioVenda => ({
                ...prevRelatorioVenda,
                [name]: value,
            }));
        }
    };

    const handleCreateRelatorioVenda = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const formattedData = formatRelatorioVendaData(newRelatorioVenda);

        createRelatorioVenda(formattedData)
            .then(createdRelatorioVenda => {
                if (createdRelatorioVenda) {
                    setCreateModalOpen(false);
                    setListAluno([]);
                    setRelacoesAlunoVendedor([]);
                    setAlunosPendentesInfo({});
                    setVendedorAtivo(0);
                    setModoRelatorio('porContrato');
                    setBuscaCodigoAluno("");
                    setNewRelatorioVenda({
                        id: 0,
                        date: "",
                        status: 0,
                        checked: false,
                        dateChecked: "",
                        empresaId: 0,
                        contratoId: 0,
                    });
                    getRelatorioVendaPaged(1, 0, objUserTk?.EmpresaId, 0, 9)
                } else {
                    console.error("Erro ao criar relatório.");
                }
            })
            .catch(error => {
                console.error("Erro ao criar relatório:", error);
            });
    };


    const handleEditInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;;
        setEditingRelatorioVenda(prevRelatorioVenda => ({
            ...prevRelatorioVenda!,
            [name]: type === 'checkbox' ? checked : value,
        }));
    }

    const handleEditRelatorioVenda = async (relatorioVenda: RelatorioVendaType) => {
        const updateData: EditRelatorioVendaType = {
            ...relatorioVenda,
            id: Number(relatorioVenda.id),
            date: relatorioVenda.date,
            status: relatorioVenda.status ? Number(relatorioVenda.status) : undefined,
            checked: Boolean(relatorioVenda.checked),
            dateChecked: relatorioVenda.dateChecked,
            empresaId: objUserTk?.EmpresaId || 0,
            contratoId: relatorioVenda.contratoId ? Number(relatorioVenda.contratoId) : undefined,
        };
        setEditingRelatorioVenda(updateData);

        await getAlunosVendedoresPaged(relatorioVenda.id, 1, 10);

        const todosVinculados = await getAlunosVendedoresByRelatorioId(relatorioVenda.id);
        setAlunosVinculados(todosVinculados || []);

        if (relatorioVenda.contratoId) {
            setAlunoPageCount(1);
            await getAlunoPaged(1, relatorioVenda.contratoId, 10);
        } else {
            setListAluno([]);
        }

        setRelacoesAlunoVendedor([]);
        setAlunosPendentesInfo({});
        setCodigoAlunoEdicao(0);
        setNomeFormandoEdicao("");
        setBuscandoNomeFormandoEdicao(false);
        setNumeroFotosEdicao(0);
        setVendedorAtivoEdicao(0);
        setEditModalOpen(true);
    };

    const handleEditSubmit = () => {
        if (editingRelatorioVenda) {

            const updatedData: EditRelatorioVendaType = {
                ...editingRelatorioVenda,
            };

            updateRelatorioVenda(updatedData)
                .then(updatedRelatorioVenda => {
                    if (updatedRelatorioVenda) {
                        setEditModalOpen(false);
                        getRelatorioVendaPaged(1, 0, objUserTk?.EmpresaId, 0, 9);
                    } else {
                        console.error("Erro ao atualizar relatório.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao atualizar relatório:", error);
                });
        }
    };

    const handleEditRelacaoInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;;
        setEditingRelacaoRelatorioVenda(prevRelacaoRelatorioVenda => ({
            ...prevRelacaoRelatorioVenda!,
            [name]: type === 'checkbox' ? checked : value,
        }));
    }

    const handleEditRelacaoRelatorioVenda = async (relacaoRelatorioVenda: AlunoVendedorType) => {
        const updateData: EditRelacaoRelatorioVendaType = {
            ...relacaoRelatorioVenda,
            id: Number(relacaoRelatorioVenda.id),
            numberPhotos: relacaoRelatorioVenda.numberPhotos,
            status: relacaoRelatorioVenda.status ? Number(relacaoRelatorioVenda.status) : 0,
        };
        setEditingRelacaoRelatorioVenda(updateData);

        if (editingRelatorioVenda) {
            await getAlunosVendedoresByRelatorioId(editingRelatorioVenda.id);
        }

        setEditRelacaoModalOpen(true);
    };

    const handleRelacaoEditSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (editingRelacaoRelatorioVenda) {

            const updatedData: EditRelacaoRelatorioVendaType = {
                ...editingRelacaoRelatorioVenda,
            };

            updateRelacoesRelatorioVenda(updatedData)
                .then(updatedRelacaoRelatorioVenda => {
                    if (updatedRelacaoRelatorioVenda) {
                        if (editingRelatorioVenda) {
                            getAlunosVendedoresPaged(editingRelatorioVenda.id, 1, 10);
                        }
                        setEditRelacaoModalOpen(false);
                    } else {
                        console.error("Erro ao atualizar relação.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao atualizar relação:", error);
                });
        }
    };

    const handleDeleteRelatorioVenda = (relatorioVendaId: number) => {
        if (window.confirm("Tem certeza que deseja excluir este relatório?")) {
            deleteRelatorioVenda(relatorioVendaId)
                .then(() => {
                    setTimeout(() => {
                        getRelatorioVendaPaged(1, 0, objUserTk?.EmpresaId, 0, 9);
                    }, 500);
                })
                .catch(error => {
                    console.error("Erro ao excluir relatório:", error);
                });
        }
    };

    const adicionarAlunoManual = async (e: any) => {
        e.preventDefault();
        if (!codigoAluno || !numeroFotos || vendedorAtivo === 0) {
            alert("Preencha código do aluno, número de fotos e selecione um vendedor.");
            return;
        }

        // const aluno = await handleGetAlunoById(codigoAluno);
        const aluno = await handleGetAlunoByReferenceCode(codigoAluno);
        if (!aluno) {
            alert("Aluno não encontrado.");
            return;
        }

        if (modoRelatorio === 'porContrato') {
            const pertenceAoContrato = await validarAlunoPertenceAoContrato(aluno.id, newRelatorioVenda.contratoId!);
            if (!pertenceAoContrato) {
                Swal.fire("Erro", "Este aluno não está vinculado ao contrato selecionado e não pode ser adicionado.", "error");
                return;
            }
        }

        const emRota = await validarAlunoEmOutroRelatorioEmRota(aluno.id);
        if (emRota) {
            const resultado = await Swal.fire({
                title: "Aluno já está em rota",
                text: `O aluno ${aluno.name} já está em outro relatório com status 'Em rota'. Deseja continuar mesmo assim?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, continuar",
                cancelButtonText: "Não, cancelar",
            });

            if (!resultado.isConfirmed) return;
        }

        const contratosAbertos = await validarVendedorComContratosAbertos(vendedorAtivo);
        if (contratosAbertos) {
            const resultado = await Swal.fire({
                title: "Vendedor com contratos abertos",
                text: "O vendedor selecionado possui contratos em aberto. Deseja continuar mesmo assim?",
                icon: "info",
                showCancelButton: true,
                confirmButtonText: "Sim, continuar",
                cancelButtonText: "Não, cancelar",
            });

            if (!resultado.isConfirmed) return;
        }

        const jaExiste = relacoesAlunoVendedor.find((a) => a.alunoId === aluno.id);
        if (jaExiste) {
            Swal.fire("Atenção", "Este aluno já foi adicionado.", "warning");
            return;
        }

        const novaRelacao: CreateRelacaoRelatorioVendaType = {
            alunoId: aluno.id,
            vendedorId: vendedorAtivo,
            numberPhotos: numeroFotos,
            status: 1,
        };

        setRelacoesAlunoVendedor((prev) => [...prev, novaRelacao]);
        setAlunosPendentesInfo((prev) => ({
            ...prev,
            [aluno.id]: { referenceCode: aluno.referenceCode, name: aluno.name }
        }));
        setCodigoAluno(0);
        setNomeFormando("");
        setBuscandoNomeFormando(false);
        setNumeroFotos(0);
        setTimeout(() => document.getElementById("codigoAlunoInput")?.focus(), 100);
    };

    const adicionarAlunoManualEdicao = async (e: any) => {
        e.preventDefault();
        if (!codigoAlunoEdicao || !numeroFotosEdicao || vendedorAtivoEdicao === 0) {
            alert("Preencha código do aluno, número de fotos e selecione um vendedor.");
            return;
        }

        // const aluno = await handleGetAlunoById(codigoAlunoEdicao);
        const aluno = await handleGetAlunoByReferenceCode(codigoAlunoEdicao);
        if (!aluno) {
            alert("Aluno não encontrado.");
            return;
        }

        if (editingRelatorioVenda?.contratoId) {
            const pertenceAoContrato = await validarAlunoPertenceAoContrato(aluno.id, editingRelatorioVenda.contratoId);
            if (!pertenceAoContrato) {
                Swal.fire("Erro", "Este aluno não pertence ao contrato deste relatório e não pode ser adicionado.", "error");
                return;
            }
        }

        const emRota = await validarAlunoEmOutroRelatorioEmRota(aluno.id);
        if (emRota) {
            const resultado = await Swal.fire({
                title: "Aluno já está em rota",
                text: `O aluno ${aluno.name} já está em outro relatório com status 'Em rota'. Deseja continuar mesmo assim?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, continuar",
                cancelButtonText: "Não, cancelar",
            });

            if (!resultado.isConfirmed) return;
        }

        const contratosAbertos = await validarVendedorComContratosAbertos(vendedorAtivoEdicao);
        if (contratosAbertos) {
            const resultado = await Swal.fire({
                title: "Vendedor com contratos abertos",
                text: "O vendedor selecionado possui contratos em aberto. Deseja continuar mesmo assim?",
                icon: "info",
                showCancelButton: true,
                confirmButtonText: "Sim, continuar",
                cancelButtonText: "Não, cancelar",
            });

            if (!resultado.isConfirmed) return;
        }

        const jaExiste = relacoesAlunoVendedor.find((a) => a.alunoId === aluno.id);
        if (jaExiste) {
            Swal.fire("Atenção", "Este aluno já foi adicionado.", "warning");
            return;
        }

        const jaVinculado = alunosVinculados.find((a) => a.alunoId === aluno.id);
        if (jaVinculado) {
            const resultado = await Swal.fire({
                title: "Aluno já vinculado",
                text: `O aluno ${aluno.name} já está neste relatório com o vendedor ${jaVinculado.vendedorNome}. Deseja adicionar mesmo assim?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, adicionar",
                cancelButtonText: "Não, cancelar",
            });

            if (!resultado.isConfirmed) return;
        }

        const novaRelacao: CreateRelacaoRelatorioVendaType = {
            alunoId: aluno.id,
            vendedorId: vendedorAtivoEdicao,
            numberPhotos: numeroFotosEdicao,
            status: 1,
        };

        setRelacoesAlunoVendedor((prev) => [...prev, novaRelacao]);
        setAlunosPendentesInfo((prev) => ({
            ...prev,
            [aluno.id]: { referenceCode: aluno.referenceCode, name: aluno.name }
        }));
        setCodigoAlunoEdicao(0);
        setNomeFormandoEdicao("");
        setBuscandoNomeFormandoEdicao(false);
        setNumeroFotosEdicao(0);
        setTimeout(() => document.getElementById("codigoAlunoInputEdicao")?.focus(), 100);
    };

    const toggleAlunoSelecionado = (alunoId: number) => {
        setAlunosSelecionadosIds((prevSelecionados) =>
            prevSelecionados.includes(alunoId)
                ? prevSelecionados.filter(id => id !== alunoId)
                : [...prevSelecionados, alunoId]
        );
    };

    const aplicarNovoStatusLote = async () => {
        if (!editingRelatorioVenda || novoStatusLote === 0 || alunosSelecionadosIds.length === 0) {
            alert("Selecione pelo menos um aluno e um status válido.");
            return;
        }

        const sucesso = await atualizarStatusLote(editingRelatorioVenda.id, {
            alunoIds: alunosSelecionadosIds,
            status: novoStatusLote
        });

        if (sucesso) {
            setAlunosSelecionadosIds([]);
            setNovoStatusLote(0);
            getAlunosVendedoresPaged(editingRelatorioVenda.id, 1, 10);
        }
    };

    const toggleSelecionarTodos = () => {
        if (todosSelecionados) {
            setAlunosSelecionadosIds([]);
        } else {
            const todosIds = listRelacaoAlunosVendedores.map((a) => a.alunoId);
            setAlunosSelecionadosIds(todosIds);
        }
        setTodosSelecionados(!todosSelecionados);
    };

    useEffect(() => {
        const todosIds = listRelacaoAlunosVendedores.map((a) => a.alunoId);
        setTodosSelecionados(
            todosIds.length > 0 && todosIds.every((id) => alunosSelecionadosIds.includes(id))
        );
    }, [alunosSelecionadosIds, listRelacaoAlunosVendedores]);

    const getStatusLabel = (status: number) => {
        switch (status) {
            case 1:
                return "Ativo";
            case 2:
                return "Baixado";
            default:
                return "Desconhecido";
        }
    };

    const getRelacaoStatusLabel = (status: number) => {
        switch (status) {
            case 1:
                return "Em rota";
            case 2:
                return "Roteiro";
            case 3:
                return "Retorno";
            case 4:
                return "Devolvido";
            case 5:
                return "Vendido";
            case 6:
                return "Descartado";
            case 7:
                return "Recusou Album";
            default:
                return "Desconhecido";
        }
    }

    const getStatusRowColor = (status: number): string => {
        switch (status) {
            case 2: return '#d1ecf1';
            case 3: return '#e8edd4';
            case 4: return '#fff3cd';
            case 5: return '#d4edda';
            case 6: return '#f8d7da';
            default: return '';
        }
    };

    const handleContratoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const contratoId = Number(e.target.value);

        setNewRelatorioVenda(prev => ({
            ...prev,
            contratoId: contratoId
        }));

        if (contratoId > 0) {
            getAlunoPaged(1, contratoId, 10);
        } else {
            setListAluno([]);
        }
    };

    function resetCampos() {
        setModoRelatorio('porContrato');
        setBuscaCodigoAluno("");
        setNewRelatorioVenda({
            id: 0,
            date: "",
            status: 0,
            checked: false,
            dateChecked: "",
            empresaId: 0,
            contratoId: 0,
        });
        setEditingRelatorioVenda(null);
        setListAluno([]);
        setRelacoesAlunoVendedor([]);
        setAlunosPendentesInfo({});
        setVendedorAtivo(0);
        setCodigoAluno(0);
        setNomeFormando("");
        setNomeFormandoEdicao("");
        setBuscandoNomeFormando(false);
        setBuscandoNomeFormandoEdicao(false);
        setNumeroFotos(0);
    }

    const vendedoresVinculadosUnicos = Array.from(
        new Map(
            alunosVinculados.map(v => [v.vendedorId, { id: v.vendedorId, nome: v.vendedorNome }])
        ).values()
    );

    const contratoOptions = listContrato.map(contrato => ({
        value: contrato.id,
        label: `${contrato.id} - ${contrato.description}`
    }));

    const vendedorOptions = listVendedores.map(v => ({
        value: v.id,
        label: v.name
    }));

    const selectedVendedor = vendedorOptions.find(v => v.value === vendedorAtivoEdicao) || null;

    if (loaging) {
        return <LoadingSpinner />;
    }

    const toggleRelatorioSelecionado = (relatorioId: number) => {
        setRelatoriosSelecionadosIds((prev) =>
            prev.includes(relatorioId)
                ? prev.filter((id) => id !== relatorioId)
                : [...prev, relatorioId]
        );
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Gerenciar relatórios de venda"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                <Form onSubmit={handleSearchSubmit}>
                    <Row className="align-items-center mb-4">
                        <Col xs="12" md="3" lg="3" className="mb-2">
                            <Label className="form-control-label" for="description">Número do Relatório</Label>
                            <Input
                                className="form-control-alternative"
                                type="number"
                                name="RelatorioId"
                                id="RelatorioId"
                                placeholder="Buscar por número do relatório"
                                value={dataSearch.RelatorioId}
                                onChange={handleSearchChange}
                            />
                        </Col>
                        <Col xs="12" md="3" lg="3" className="mb-2">
                            <Label className="form-control-label" for="description">Nº Contrato</Label>
                            <Input
                                className="form-control-alternative"
                                type="number"
                                name="ContratoId"
                                id="ContratoId"
                                placeholder="Buscar por número do contrato"
                                value={dataSearch.ContratoId}
                                onChange={handleSearchChange}
                            />
                        </Col>
                        <Col xs="12" md="6" lg="6" className="mb-2">
                            <Label className="form-control-label" for="status">Status</Label>
                            <Input
                                className="form-control-alternative"
                                type="select"
                                name="Status"
                                id="Status"
                                value={dataSearch.Status}
                                onChange={handleSearchChange}
                            >
                                <option value={0}>Selecione um Status</option>
                                <option value={1}>Ativo</option>
                                <option value={2}>Baixado</option>
                            </Input>
                        </Col>
                    </Row>
                    <Row className="align-items-center mb-4">
                        <Col xs="12" md="3" lg="3" className="mb-2">
                            <Label className="form-control-label" for="InitialDate">Data Inicial</Label>
                            <Input
                                className="form-control-alternative"
                                type="date"
                                name="InitialDate"
                                id="InitialDate"
                                value={dataSearch.InitialDate}
                                onChange={handleSearchChange}
                            />
                        </Col>
                        <Col xs="12" md="3" lg="3" className="mb-2">
                            <Label className="form-control-label" for="FinalDate">Data Final</Label>
                            <Input
                                className="form-control-alternative"
                                type="date"
                                name="FinalDate"
                                id="FinalDate"
                                value={dataSearch.FinalDate}
                                onChange={handleSearchChange}
                            />
                        </Col>
                        <Col xs="12" md="6" lg="6" className="d-flex justify-content-start justify-content-md-end mb-2">
                            <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">
                                Buscar
                            </Button>
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                type="button"
                                size="m"
                                onClick={handleClearFilters}
                            >
                                Limpar
                            </Button>
                        </Col>
                        {hasPermission(PermissionModule.RelatorioVendas, 1) && (
                            <Col xs="12" className="text-right mt-3">
                                <Button
                                    color="success"
                                    disabled={relatoriosSelecionadosIds.length === 0}
                                    onClick={() => downloadRelatorioMultiplosPdf(objUserTk.EmpresaId, relatoriosSelecionadosIds)}
                                >
                                    <i className="fa-solid fa-file-pdf mr-2"></i> Exportar Relatório de Múltiplas Vendas
                                </Button>
                                <Button
                                    style={{ backgroundColor: '#007bff', color: '#FFF' }}
                                    // onClick={() => downloadRelatorioVendasAtivasPdf(objUserTk.EmpresaId)}
                                    onClick={() => {
                                        setVendedorFiltroExport(0);
                                        setStatusFiltroExport(0);
                                        setExportModalOpen(true);
                                    }}
                                >
                                    <i className="fa-solid fa-file-pdf mr-2"></i> Exportar Relatório de Vendas Ativas
                                </Button>
                                <Button
                                    style={{ color: "#FFF", backgroundColor: "#585858" }}
                                    size="m"
                                    onClick={() => { setCreateModalOpen(true); resetCampos(); setAlunoSearch({ name: "", alunoId: "" }); }}
                                >
                                    Adicionar relatório
                                </Button>
                            </Col>
                        )}
                    </Row>
                </Form>
                {hasPermission(PermissionModule.RelatorioVendas, 2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped">
                                <thead>
                                    <tr>
                                        <th>
                                            <Input
                                                type="checkbox"
                                                style={{
                                                    position: 'static',
                                                    marginTop: 0,
                                                    marginLeft: 0
                                                }}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        const allIds = listRelatorioVenda.map(r => r.id);
                                                        setRelatoriosSelecionadosIds(allIds);
                                                    } else {
                                                        setRelatoriosSelecionadosIds([]);
                                                    }
                                                }}
                                                checked={listRelatorioVenda.length > 0 && relatoriosSelecionadosIds.length === listRelatorioVenda.length}
                                            />
                                        </th>
                                        <th>Documento</th>
                                        <th>Data</th>
                                        <th>Contrato</th>
                                        <th>Vendedor</th>
                                        <th>Status</th>
                                        <th>Conferido</th>
                                        <th>Data Conferido</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listRelatorioVenda.map(item => (
                                        <tr key={item.id} style={item.status === 2 ? { backgroundColor: "#e8f7e4" } : undefined}>
                                            <td>
                                                <Input
                                                    type="checkbox"
                                                    style={{
                                                        position: 'static',
                                                        marginTop: 0,
                                                        marginLeft: 0
                                                    }}
                                                    checked={relatoriosSelecionadosIds.includes(item.id)}
                                                    onChange={() => toggleRelatorioSelecionado(item.id)}
                                                />
                                            </td>
                                            <td>{item.id}</td>
                                            <td>{item.date ? new Intl.DateTimeFormat('pt-BR').format(new Date(item.date)) : ""}</td>
                                            <td>{item.contratoId || <span style={{ color: '#888', fontStyle: 'italic' }}>Por aluno</span>}</td>
                                            <td>{item.vendedorNome || <span style={{ color: '#888', fontStyle: 'italic' }}>-</span>}</td>
                                            <td>{getStatusLabel(Number(item.status))}</td>
                                            <td>{item.checked ? "Sim" : "Não"}</td>
                                            <td>{item.dateChecked ? item.dateChecked : "Data ainda não definida"}</td>
                                            <td>
                                                <Button onClick={() => { handleEditRelatorioVenda(item); setAlunoSearch({ name: "", alunoId: "" }); }}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                <Button onClick={() => handleDeleteRelatorioVenda(item.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-end mt-3">
                                {relatorioVendaPageCount && (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={relatorioVendaPageCount}
                                        />
                                    </div>
                                )}
                                {listRelatorioVenda.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar os relatórios de venda.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <Modal isOpen={createModalOpen} toggle={() => {
                setCreateModalOpen(!createModalOpen);
            }} backdrop="static" size="xl">
                <ModalHeader toggle={() => setCreateModalOpen(!createModalOpen)}>Adicionar Relatório de Venda</ModalHeader>
                <ModalBody>
                    {/* Seleção de modo */}
                    <Row className="mb-3">
                        <Col>
                            <div className="d-flex" style={{ gap: 16 }}>
                                <Label check style={{ cursor: 'pointer', fontWeight: modoRelatorio === 'porContrato' ? 700 : 400 }}>
                                    <input
                                        type="radio"
                                        name="modoRelatorio"
                                        value="porContrato"
                                        checked={modoRelatorio === 'porContrato'}
                                        onChange={() => {
                                            setModoRelatorio('porContrato');
                                            setBuscaCodigoAluno("");
                                            setListAluno([]);
                                            setRelacoesAlunoVendedor([]);
                                        }}
                                        style={{ marginRight: 6 }}
                                    />
                                    Por Contrato
                                </Label>
                                <Label check style={{ cursor: 'pointer', fontWeight: modoRelatorio === 'porAluno' ? 700 : 400 }}>
                                    <input
                                        type="radio"
                                        name="modoRelatorio"
                                        value="porAluno"
                                        checked={modoRelatorio === 'porAluno'}
                                        onChange={() => {
                                            setModoRelatorio('porAluno');
                                            setNewRelatorioVenda(prev => ({ ...prev, contratoId: 0 }));
                                            setListAluno([]);
                                            setRelacoesAlunoVendedor([]);
                                            setBuscaCodigoAluno("");
                                        }}
                                        style={{ marginRight: 6 }}
                                    />
                                    Por Código
                                </Label>
                            </div>
                        </Col>
                    </Row>

                    <Form onSubmit={handleCreateRelatorioVenda}>
                        <Row>
                            <Col md="6">
                                {modoRelatorio === 'porContrato' ? (
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="contratoId">
                                            Contrato
                                        </Label>
                                        <Select
                                            className="form-control-alternative"
                                            options={contratoOptions}
                                            value={contratoOptions.find(opt => opt.value === newRelatorioVenda.contratoId)}
                                            onChange={(selectedOption) => {
                                                const contratoId = selectedOption?.value || 0;
                                                setNewRelatorioVenda(prev => ({ ...prev, contratoId: contratoId }));
                                                if (contratoId > 0) {
                                                    getAlunoPaged(1, contratoId, 10);
                                                } else {
                                                    setListAluno([]);
                                                }
                                            }}
                                            placeholder="Selecione ou pesquise um contrato..."
                                            isClearable
                                        />
                                    </FormGroup>
                                ) : (
                                    <FormGroup>
                                        <Label className="form-control-label">Buscar aluno por código</Label>
                                        <div className="d-flex" style={{ gap: 8 }}>
                                            <Input
                                                className="form-control-alternative"
                                                type="number"
                                                placeholder="Digite o código do aluno..."
                                                value={buscaCodigoAluno}
                                                onChange={(e) => setBuscaCodigoAluno(e.target.value)}
                                                onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
                                            />
                                            <Button
                                                type="button"
                                                style={{ backgroundColor: '#585858', color: '#FFF', whiteSpace: 'nowrap' }}
                                                onClick={() => {
                                                    if (buscaCodigoAluno.trim()) {
                                                        getAlunoPaged(1, 0, 10, undefined, undefined, undefined, Number(buscaCodigoAluno.trim()), objUserTk.EmpresaId);
                                                    }
                                                }}
                                            >
                                                Buscar
                                            </Button>
                                        </div>
                                        <small className="text-muted">
                                            Os alunos encontrados aparecerão abaixo para adição ao relatório.
                                        </small>
                                    </FormGroup>
                                )}
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="date">
                                        Data
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="date"
                                        name="date"
                                        id="date"
                                        value={newRelatorioVenda.date?.toString() || ""}
                                        onChange={handleCreateInputChange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="status">
                                        Status
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        name="status"
                                        id="status"
                                        value={newRelatorioVenda.status}
                                        onChange={handleCreateInputChange}
                                    >
                                        <option value={0}>Selecione um Status</option>
                                        <option value={1}>Ativo</option>
                                        <option value={2}>Baixado</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="vendedorAtivo">
                                        Vendedor atual
                                    </Label>
                                    <Select
                                        className="form-control-alternative"
                                        options={vendedorOptions}
                                        value={vendedorOptions.find(opt => opt.value === vendedorAtivo)}
                                        onChange={(selectedOption) => setVendedorAtivo(selectedOption?.value || 0)}
                                        placeholder="Selecione ou digite para buscar..."
                                        isClearable
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                type="submit"
                                size="m"
                            >
                                Criar Preparação
                            </Button>
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                className="ml-2"
                                onClick={() => { setCreateModalOpen(false); getRelatorioVendaPaged(1, 0, objUserTk.EmpresaId, 0, 9); }}
                                size="m"
                            >
                                Cancelar
                            </Button>
                        </div>
                    </Form>
                    {listAluno.length > 0 && (
                        <>
                            <hr />
                            <h4>{modoRelatorio === 'porAluno' ? 'Alunos encontrados' : 'Alunos vinculados ao contrato'}</h4>
                            <Form onSubmit={adicionarAlunoManual} className="mb-4">
                                <Row>
                                    <Col md="4">
                                        <Label className="form-control-label">Nome do formando</Label>
                                        <Input
                                            className="form-control-alternative mb-2"
                                            type="text"
                                            value={buscandoNomeFormando ? "Buscando..." : nomeFormando}
                                            placeholder={codigoAluno ? "Aluno não encontrado" : "Digite o código do aluno"}
                                            disabled
                                        />
                                        <Label className="form-control-label">Código do Aluno</Label>
                                        <Input
                                            id="codigoAlunoInput"
                                            className="form-control-alternative"
                                            type="number"
                                            value={codigoAluno || ""}
                                            onChange={(e) => setCodigoAluno(Number(e.target.value))}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    document.getElementById("inputFotos")?.focus();
                                                }
                                                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onWheel={(e) => e.currentTarget.blur()}
                                            autoFocus
                                        />
                                    </Col>
                                    <Col md="4">
                                        <Label className="form-control-label">Número de Fotos</Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="number"
                                            id="inputFotos"
                                            value={numeroFotos || ""}
                                            onChange={(e) => setNumeroFotos(Number(e.target.value))}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    adicionarAlunoManual(e);
                                                }
                                            }}
                                            disabled={!codigoAluno}
                                        />
                                    </Col>
                                    <Col md="4" className="d-flex align-items-end">
                                        <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit">Adicionar</Button>
                                    </Col>
                                </Row>
                            </Form>
                            {relacoesAlunoVendedor.length > 0 && (
                                <Table striped responsive className="table-striped">
                                    <thead>
                                        <tr>
                                            <th>Código</th>
                                            <th>Aluno</th>
                                            <th>Vendedor</th>
                                            <th>Fotos</th>
                                            <th>Status</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {relacoesAlunoVendedor.map((relacao) => {
                                            const aluno = listAluno.find(a => a.id === relacao.alunoId)
                                                || alunosPendentesInfo[relacao.alunoId];

                                            return (
                                                <tr key={relacao.alunoId}>
                                                    <td>{aluno?.referenceCode ?? "-"}</td>
                                                    <td>{aluno?.name || "-"}</td>
                                                    <td>
                                                        {listVendedores.find(v => v.id === relacao.vendedorId)?.name || "-"}
                                                    </td>
                                                    <td>{relacao.numberPhotos}</td>
                                                    <td>{getRelacaoStatusLabel(Number(relacao.status))}</td>
                                                    <td>
                                                        <Button
                                                            color="danger"
                                                            onClick={() =>
                                                                setRelacoesAlunoVendedor(prev =>
                                                                    prev.filter(r => r.alunoId !== relacao.alunoId)
                                                                )
                                                            }
                                                        >
                                                            x
                                                        </Button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            )}
                        </>
                    )}
                </ModalBody>
            </Modal >

            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(!editModalOpen)} backdrop="static" size="xl">
                <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>Editar Relatório de Venda</ModalHeader>
                <ModalBody>
                    {editingRelatorioVenda && (
                        // <Form onSubmit={handleEditSubmit}>
                        <div>
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="contratoId">
                                            Contrato
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="select"
                                            name="contratoId"
                                            id="contratoId"
                                            value={editingRelatorioVenda.contratoId}
                                            onChange={handleEditInputChange}
                                            disabled
                                        >
                                            <option value={0}>Selecione um Contrato</option>
                                            {listContrato.map((contrato) => (
                                                <option key={contrato.id} value={contrato.id}>
                                                    {`${contrato.id} - ${contrato.description}`}
                                                </option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="date">
                                            Data
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="date"
                                            name="date"
                                            id="date"
                                            value={editingRelatorioVenda.date?.toString() || ""}
                                            onChange={handleEditInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="status">
                                            Status
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="select"
                                            name="status"
                                            id="status"
                                            value={editingRelatorioVenda.status}
                                            onChange={handleEditInputChange}
                                        >
                                            <option value={0}>Selecione um Status</option>
                                            <option value={1}>Ativo</option>
                                            <option value={2}>Baixado</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="vendedores">
                                            Vendedores
                                        </Label>
                                        {vendedoresVinculadosUnicos.length > 0 && (
                                            <>
                                                <div className="d-flex flex-wrap">
                                                    {vendedoresVinculadosUnicos.map((v) => (
                                                        <span key={v.id} className="badge badge-primary mr-2 mb-2" style={{ fontSize: '14px', padding: '8px 12px' }}>
                                                            {v.nome}
                                                        </span>
                                                    ))}
                                                </div>
                                            </>
                                        )}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-end mt-3">
                                <Button
                                    style={{ color: "#FFF", backgroundColor: "#585858" }}
                                    // type="submit"
                                    onClick={handleEditSubmit}
                                    size="m"
                                >
                                    Salvar alterações
                                </Button>
                                <Button
                                    style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                    className="ml-2"
                                    onClick={() => setEditModalOpen(false)}
                                    size="m"
                                >
                                    Cancelar
                                </Button>
                            </div>
                            {alunosVinculados.length > 0 && (
                                <>
                                    <hr />
                                    <h4>Alunos vinculados</h4>
                                    <>
                                    <Form onSubmit={handleAlunoVendedorSearchSubmit} className='mt-4'>
                                        <Row className="align-items-center mb-4">
                                            <Col xs="12" md="4" lg="4" className="mb-2">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="name">Nome do Aluno</Label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="text"
                                                        name="name"
                                                        id="name"
                                                        placeholder="Buscar por nome"
                                                        value={alunoVendedorSearch.name}
                                                        onChange={(e) => setAlunoVendedorSearch({ ...alunoVendedorSearch, name: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xs="12" md="4" lg="4" className="mb-2">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="alunoId">Código do Aluno</Label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="number"
                                                        name="alunoId"
                                                        id="alunoId"
                                                        placeholder="Buscar por Código"
                                                        value={alunoVendedorSearch.alunoId}
                                                        onChange={(e) => setAlunoVendedorSearch({ ...alunoVendedorSearch, alunoId: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xs="12" md="4" lg="4" className="d-flex justify-content-start justify-content-md-end mb-2">
                                                <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m" className="mr-2">
                                                    Buscar
                                                </Button>
                                                <Button
                                                    style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                                    type="button"
                                                    size="m"
                                                    onClick={() => {
                                                        setAlunoVendedorSearch({ name: "", alunoId: "" });
                                                        if (editingRelatorioVenda?.id) {
                                                            getAlunosVendedoresPaged(editingRelatorioVenda.id, 1, 10);
                                                        }
                                                    }}
                                                >
                                                    Limpar
                                                </Button>
                                            </Col>
                                        </Row>
                                        <Row className="align-items-center mb-3">
                                            <Col xs="12" md="4" lg="4">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="vendedorFiltroPdf">Filtrar por Vendedor</Label>
                                                    <Select
                                                        id="vendedorFiltroPdf"
                                                        className="form-control-alternative"
                                                        options={vendedorOptions}
                                                        value={vendedorOptions.find(opt => opt.value === vendedorAtivoEdicao) || null}
                                                        onChange={(selectedOption) => setVendedorAtivoEdicao(selectedOption?.value || 0)}
                                                        placeholder="Selecione um vendedor"
                                                        isClearable
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xs="12" md="4" lg="4">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="statusFiltroPdf">Filtrar por Status</Label>
                                                    <Input
                                                        id="statusFiltroPdf"
                                                        className="form-control-alternative"
                                                        type="select"
                                                        value={novoStatusLote}
                                                        onChange={(e) => setNovoStatusLote(Number(e.target.value))}
                                                    >
                                                        <option value={0}>Todos os status</option>
                                                        <option value={1}>Em rota</option>
                                                        <option value={2}>Roteiro</option>
                                                        <option value={3}>Retorno</option>
                                                        <option value={4}>Devolvido</option>
                                                        <option value={5}>Vendido</option>
                                                        <option value={6}>Descartado</option>
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col xs="12" md="4" lg="4" className="d-flex align-items-end justify-content-end">
                                                <Button
                                                    style={{ backgroundColor: '#007bff', color: '#FFF' }}
                                                    onClick={() =>
                                                        downloadRelatorioVendaPdf(
                                                            editingRelatorioVenda!.id,
                                                            vendedorAtivoEdicao !== 0 ? vendedorAtivoEdicao : undefined,
                                                            novoStatusLote !== 0 ? novoStatusLote : undefined
                                                        )
                                                    }
                                                >
                                                    <i className="fa-solid fa-file-pdf mr-2"></i> Exportar PDF
                                                </Button>
                                                <Button
                                                    style={{ backgroundColor: '#007bff', color: '#FFF' }}
                                                    onClick={() =>
                                                        downloadRelatorioReduzidoVendaPdf(
                                                            editingRelatorioVenda!.id,
                                                            vendedorAtivoEdicao !== 0 ? vendedorAtivoEdicao : undefined,
                                                            novoStatusLote !== 0 ? novoStatusLote : undefined
                                                        )
                                                    }
                                                >
                                                    <i className="fa-solid fa-file-pdf mr-2"></i> Exportar PDF Reduzido
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>

                                    {alunosSelecionadosIds.length > 0 && (
                                        <Row className="mb-3">
                                            <Col md="10">
                                                <Label className="form-control-label">Status para selecionados</Label>
                                                <Input
                                                    className="form-control-alternative"
                                                    type="select"
                                                    value={novoStatusLote}
                                                    onChange={(e) => setNovoStatusLote(Number(e.target.value))}
                                                >
                                                    <option value={0}>Selecione um status</option>
                                                    <option value={1}>Em rota</option>
                                                    <option value={2}>Roteiro</option>
                                                    <option value={3}>Retorno</option>
                                                    <option value={4}>Devolvido</option>
                                                    <option value={5}>Vendido</option>
                                                    <option value={6}>Descartado</option>
                                                </Input>
                                            </Col>
                                            <Col md="2" className="d-flex align-items-end">
                                                <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="button" size="m" onClick={aplicarNovoStatusLote}>
                                                    Aplicar status
                                                </Button>
                                            </Col>
                                        </Row>
                                    )}

                                    <Table striped responsive className="table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <Input
                                                        className="ml-2 mt--3"
                                                        type="checkbox"
                                                        checked={todosSelecionados}
                                                        onChange={toggleSelecionarTodos}
                                                    />
                                                </th>
                                                <th>Código</th>
                                                <th>Nome do Aluno</th>
                                                <th>Nº Vendedor</th>
                                                <th>Nome do Vendedor</th>
                                                <th>Curso</th>
                                                <th>Número de fotos</th>
                                                <th>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listRelacaoAlunosVendedores
                                                .sort((a, b) => a.vendedorNome.localeCompare(b.vendedorNome))
                                                .map((item, index) => (
                                                    <tr key={index} style={{ backgroundColor: getStatusRowColor(item.status) }}>
                                                        <td>
                                                            <Input
                                                                className='ml-2'
                                                                type="checkbox"
                                                                checked={alunosSelecionadosIds.includes(item.alunoId)}
                                                                onChange={() => toggleAlunoSelecionado(item.alunoId)}
                                                            />
                                                        </td>
                                                        <td>{item.alunoId}</td>
                                                        <td>{item.alunoNome}</td>
                                                        <td>{item.vendedorId}</td>
                                                        <td>{item.vendedorNome}</td>
                                                        <td>{item.cursoNome}</td>
                                                        <td>{item.numberPhotos}</td>
                                                        <td>{getRelacaoStatusLabel(item.status)}</td>
                                                        <td>
                                                            <Button onClick={() => handleEditRelacaoRelatorioVenda(item)}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                            <Button
                                                                color="danger"
                                                                onClick={async () => {
                                                                    if (
                                                                        editingRelatorioVenda &&
                                                                        window.confirm("Deseja realmente remover esse vínculo?")
                                                                    ) {
                                                                        const result = await removerRelacaoRelatorioVenda(
                                                                            editingRelatorioVenda.id,
                                                                            item.alunoId,
                                                                            item.vendedorId
                                                                        );
                                                                        if (result) {
                                                                            const atualizados = await getAlunosVendedoresByRelatorioId(
                                                                                editingRelatorioVenda.id
                                                                            );
                                                                            setAlunosVinculados(atualizados || []);
                                                                            await getAlunosVendedoresPaged(editingRelatorioVenda.id, 1, 10);
                                                                            setAlunosSelecionadosIds([]);
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                <i className="fa-solid fa-trash"></i>
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </Table>
                                    <div className="d-flex justify-content-end mt-3">
                                        {relacaoAlunosVendedoresPageCount && (
                                            <div className="d-flex justify-content-center mt-4">
                                                <PaginationMaterial
                                                    onChange={(e: any, value: any) => onChangeAlunoVendedorPagination(e, value)}
                                                    count={relacaoAlunosVendedoresPageCount}
                                                />
                                            </div>
                                        )}
                                        {listRelacaoAlunosVendedores.length === 0 && (
                                            <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                        )}
                                    </div>
                                    </>
                                </>
                            )}
                            {editingRelatorioVenda && (
                                <>
                                    <hr />
                                    <h4>
                                        {editingRelatorioVenda.contratoId
                                            ? "Selecionar novos alunos do contrato"
                                            : "Adicionar novos formandos por código"}
                                    </h4>
                                    {!editingRelatorioVenda.contratoId && (
                                        <small className="text-muted d-block mb-2">
                                            Este relatório não está vinculado a um contrato. Informe o código do formando para adicioná-lo.
                                        </small>
                                    )}
                                    <Form onSubmit={adicionarAlunoManualEdicao} className="mb-4">
                                        <Row>
                                            <Col md="3">
                                                <Label className="form-control-label">Nome do formando</Label>
                                                <Input
                                                    className="form-control-alternative mb-2"
                                                    type="text"
                                                    value={buscandoNomeFormandoEdicao ? "Buscando..." : nomeFormandoEdicao}
                                                    placeholder={codigoAlunoEdicao ? "Aluno não encontrado" : "Digite o código do aluno"}
                                                    disabled
                                                />
                                                <Label className="form-control-label">Código do Aluno</Label>
                                                <Input
                                                    id="codigoAlunoInputEdicao"
                                                    className="form-control-alternative"
                                                    type="number"
                                                    value={codigoAlunoEdicao || ""}
                                                    onChange={(e) => setCodigoAlunoEdicao(Number(e.target.value))}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            document.getElementById("inputFotosEdicao")?.focus();
                                                        }
                                                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    onWheel={(e) => e.currentTarget.blur()}
                                                    autoFocus
                                                />
                                            </Col>

                                            <Col md="3">
                                                <Label className="form-control-label">Número de Fotos</Label>
                                                <Input
                                                    className="form-control-alternative"
                                                    type="number"
                                                    id="inputFotosEdicao"
                                                    value={numeroFotosEdicao || ""}
                                                    onChange={(e) => setNumeroFotosEdicao(Number(e.target.value))}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            adicionarAlunoManualEdicao(e);
                                                        }
                                                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    onWheel={(e) => e.currentTarget.blur()}
                                                    disabled={!codigoAlunoEdicao}
                                                />
                                            </Col>

                                            <Col md="4">
                                                <Label className="form-control-label">Vendedor</Label>
                                                <Select
                                                    className="form-control-alternative"
                                                    value={selectedVendedor}
                                                    onChange={(selectedOption) =>
                                                        setVendedorAtivoEdicao(selectedOption?.value || 0)
                                                    }
                                                    options={vendedorOptions}
                                                    placeholder="Selecione ou pesquise um vendedor"
                                                    isClearable
                                                    isSearchable
                                                />
                                            </Col>

                                            <Col md="2" className="d-flex align-items-end">
                                                <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit">Adicionar</Button>
                                            </Col>
                                        </Row>
                                    </Form>

                                    {relacoesAlunoVendedor.length > 0 && (
                                        <Table striped responsive className="table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Código</th>
                                                    <th>Aluno</th>
                                                    <th>Vendedor</th>
                                                    <th>Fotos</th>
                                                    <th>Status</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {relacoesAlunoVendedor.map((relacao) => {
                                                    const aluno = listAluno.find(a => a.id === relacao.alunoId)
                                                        || alunosPendentesInfo[relacao.alunoId];

                                                    return (
                                                        <tr key={relacao.alunoId}>
                                                            <td>{aluno?.referenceCode ?? "-"}</td>
                                                            <td>{aluno?.name || "-"}</td>
                                                            <td>{listVendedores.find(v => v.id === relacao.vendedorId)?.name || "-"}</td>
                                                            <td>{relacao.numberPhotos}</td>
                                                            <td>{getRelacaoStatusLabel(Number(relacao.status))}</td>
                                                            <td>
                                                                <Button
                                                                    color="danger"
                                                                    onClick={() =>
                                                                        setRelacoesAlunoVendedor(prev =>
                                                                            prev.filter(r => r.alunoId !== relacao.alunoId)
                                                                        )
                                                                    }
                                                                >
                                                                    x
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    )}
                                </>
                            )}
                            {relacoesAlunoVendedor.length > 0 && (
                                <div className="d-flex justify-content-end mt-3">
                                    <Button
                                        style={{ color: "#FFF", backgroundColor: "#585858" }}
                                        onClick={async () => {
                                            const result = await adicionarRelacoesAoRelatorio(
                                                editingRelatorioVenda!.id,
                                                relacoesAlunoVendedor
                                            );
                                            if (result) {
                                                const updated = await getAlunosVendedoresByRelatorioId(editingRelatorioVenda!.id);
                                                if (updated) {
                                                    setAlunosVinculados(updated);
                                                    await getAlunosVendedoresPaged(editingRelatorioVenda!.id, 1, 10);
                                                    setAlunosSelecionadosIds([]);
                                                }
                                                setRelacoesAlunoVendedor([]);
                                                setAlunosPendentesInfo({});
                                            }
                                        }}
                                    >
                                        Adicionar novos vínculos
                                    </Button>
                                </div>
                            )}
                        </div>
                        // </Form>
                    )}
                </ModalBody>
            </Modal>
            <Modal isOpen={editRelacaoModalOpen} toggle={() => setEditRelacaoModalOpen(!editRelacaoModalOpen)} backdrop="static" size="xl">
                <ModalHeader toggle={() => setEditRelacaoModalOpen(!editRelacaoModalOpen)}>Editar Relação</ModalHeader>
                <ModalBody>
                    {editingRelacaoRelatorioVenda && (
                        <Form onSubmit={handleRelacaoEditSubmit}>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="numberPhotos">
                                            Número de fotos
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="number"
                                            name="numberPhotos"
                                            id="numberPhotos"
                                            value={editingRelacaoRelatorioVenda.numberPhotos}
                                            onChange={handleEditRelacaoInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="status">
                                            Status
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="select"
                                            name="status"
                                            id="status"
                                            value={editingRelacaoRelatorioVenda.status}
                                            onChange={handleEditRelacaoInputChange}
                                        >
                                            <option value={0}>Selecione um Status</option>
                                            <option value={1}>Em rota</option>
                                            <option value={2}>Roteiro</option>
                                            <option value={3}>Retorno</option>
                                            <option value={4}>Devolvido</option>
                                            <option value={5}>Vendido</option>
                                            <option value={6}>Descartado</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-end mt-3">
                                <Button
                                    style={{ color: "#FFF", backgroundColor: "#585858" }}
                                    type="submit"
                                    size="m"
                                >
                                    Salvar alterações
                                </Button>
                                <Button
                                    style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                    className="ml-2"
                                    onClick={() => setEditRelacaoModalOpen(false)}
                                    size="m"
                                >
                                    Cancelar
                                </Button>
                            </div>
                        </Form>
                    )}
                </ModalBody>
            </Modal>
            <Modal
                isOpen={exportModalOpen}
                toggle={() => setExportModalOpen(!exportModalOpen)}
                backdrop="static"
            >
                <ModalHeader toggle={() => setExportModalOpen(!exportModalOpen)}>
                    Exportar Relatório de Vendas Ativas
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label className="form-control-label">
                                Selecione um vendedor (opcional)
                            </Label>
                            <Select
                                className="form-control-alternative"
                                options={vendedorOptions}
                                value={vendedorOptions.find(
                                    (v) => v.value === vendedorFiltroExport
                                ) || null}
                                onChange={(opt) =>
                                    setVendedorFiltroExport(opt?.value || 0)
                                }
                                placeholder="Digite para filtrar vendedores…"
                                isClearable
                                isSearchable
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Status (opcional)</Label>
                            <Input
                                type="select"
                                value={statusFiltroExport}
                                onChange={(e) => setStatusFiltroExport(Number(e.target.value))}
                            >
                                <option value={0}>Todos</option>
                                <option value={1}>Em rota</option>
                                <option value={2}>Roteiro</option>
                                <option value={3}>Retorno</option>
                                <option value={4}>Devolvido</option>
                                <option value={5}>Vendido</option>
                                <option value={6}>Descartado</option>
                            </Input>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter className="d-flex justify-content-end">
                    <Button
                        style={{ backgroundColor: '#007bff', color: '#FFF' }}
                        onClick={async () => {
                            await downloadRelatorioVendasAtivasPdf(
                                objUserTk.EmpresaId,
                                vendedorFiltroExport || undefined,
                                statusFiltroExport || undefined
                            );
                            setExportModalOpen(false);
                        }}
                    >
                        <i className="fa-solid fa-file-pdf mr-2"></i>
                        Exportar PDF
                    </Button>
                    <Button
                        style={{ backgroundColor: '#d9534f', color: '#FFF' }}
                        onClick={() => setExportModalOpen(false)}
                    >
                        Cancelar
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default RelatorioVenda;
